import React from "react";
import useWishlistActions from "utils/wishlistUtils";
import toast from "react-hot-toast";

export interface LikeButtonProps {
  className?: string;
  liked?: boolean;
  productData?: any; // Product data to add to wishlist
}

const LikeButton: React.FC<LikeButtonProps> = ({
  className = "",
  liked = false,
  productData,
}) => {
  const { toggleItem, isInWishlist } = useWishlistActions();
  
  // Check if product is in wishlist
  const productId = productData ? (productData.id || productData.product_id) : null;
  const isLiked = productId ? isInWishlist(productId) : liked;

  const handleToggleWishlist = () => {
    if (productData) {
      // Ensure we have the required fields for wishlist
      const wishlistItem = {
        id: productData.id || productData.product_id || Math.random(),
        name: productData.name || productData.product_name || "Unknown Product",
        price: productData.price || productData.sales_rate || productData.selling_price || 0,
        image: productData.image || productData.image1 || productData.product_image || "",
        image1: productData.image1 || productData.image || productData.product_image || "",
        description: productData.description || productData.product_description || "",
        sales_rate: productData.sales_rate || productData.price || 0,
        status: productData.status || "",
        slug: productData.slug || "",
      };
      
      toggleItem(wishlistItem);
      
      // Show toast notification
      if (isLiked) {
        toast.success("Removed from wishlist!");
      } else {
        toast.success("Added to wishlist!");
      }
    }
  };

  return (
    <button
      className={`w-9 h-9 flex items-center justify-center rounded-full bg-white dark:bg-slate-900 text-neutral-700 dark:text-slate-200 nc-shadow-lg transition-colors duration-200 hover:bg-red-50 dark:hover:bg-red-900/20 ${className}`}
      onClick={handleToggleWishlist}
      title={isLiked ? "Remove from wishlist" : "Add to wishlist"}
    >
      <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none">
        <path
          d="M12.62 20.81C12.28 20.93 11.72 20.93 11.38 20.81C8.48 19.82 2 15.69 2 8.68998C2 5.59998 4.49 3.09998 7.56 3.09998C9.38 3.09998 10.99 3.97998 12 5.33998C13.01 3.97998 14.63 3.09998 16.44 3.09998C19.51 3.09998 22 5.59998 22 8.68998C22 15.69 15.52 19.82 12.62 20.81Z"
          stroke={isLiked ? "#ef4444" : "currentColor"}
          fill={isLiked ? "#ef4444" : "none"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

export default LikeButton;
